import React from "react";
import { twMerge } from "tailwind-merge";
import { useContextCalendars } from "@rehookify/datepicker";

import { SupPopover } from "../../../../components/UI/Popover";
import { Calendar } from "./Calendar";

interface CalendarPopoverProps {
  className?: string;
  anchorEl?: HTMLElement | null;
  open?: boolean;
  displayTimePicker?: boolean;
  onClose?: () => void;
  onChange?: (date?: Date) => void;
}

const POPOVER_OFFSET: [number, number] = [0, 8]; // offset in PX

export function CalendarPopover({ className, anchorEl, open, displayTimePicker = false, onClose, onChange }: CalendarPopoverProps) {
  const {
    calendars: [calendar],
  } = useContextCalendars();

  return (
    <SupPopover portal offset={POPOVER_OFFSET} open={open} anchorEl={anchorEl} onClickOutside={onClose} className={twMerge(className, "shadow")}>
      <Calendar displayTimePicker={displayTimePicker} data={calendar} onClose={onClose} onChange={onChange} />
    </SupPopover>
  );
}
